import axios from 'axios';
import ErrorBoundary from './ErrorBoundary';
import { installErrorLogging } from './utils/errorLogger';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import '@fontsource/barlow/400.css';
import '@fontsource/barlow/500.css';
import '@fontsource/barlow/600.css';
import '@fontsource/barlow/700.css';
import '@fontsource/jetbrains-mono/500.css';
import './index.css';
import App from './App';

installErrorLogging(axios);

window.__tilbudgivernBootStartedAt = window.performance?.now?.() || 0;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ErrorBoundary><App /></ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>
);
